module.exports = __webpack_public_path__ + "img/a_share.bb0dfec3.png";